// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import VueStripeCheckout from 'vue-stripe-checkout'
// import { STRIPE_KEY } from '@/common/config'

import App from './App'
import router from '@/router'
import store from '@/store'
import { CHECK_AUTH } from '@/store/actions.type'

import ApiService from '@/common/api.service'
import DateFilter from '@/common/date.filter'
import ErrorFilter from '@/common/error.filter'
import BootstrapVue from 'bootstrap-vue'

Vue.config.productionTip = false
Vue.filter('date', DateFilter)
Vue.filter('error', ErrorFilter)
Vue.use(BootstrapVue)

// base/global options
// these options can be overridden
// by the options in the .open(options)
// function.
// const options = {
//   key: STRIPE_KEY,
//   image: 'https://cdn.meme.am/images/100x100/15882140.jpg',
//   locale: 'auto',
//   billingAddress: true,
//   panelLabel: 'Subscribe {{amount}}'
// }
// Vue.use(VueStripeCheckout, STRIPE_KEY);

// Vue.use(VueStripeCheckout, options)

ApiService.init()

// Ensure we checked auth before each page load.
router.beforeEach(
  (to, from, next) => {
    return Promise
      .all([store.dispatch(CHECK_AUTH)])
      .then(next)
  }
)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js